import {EventCalendar} from '../../../+calendar/see-calendar/shared/models/event-calendar.model';

export class Room {
  private _id: number;
  private _allowedParticipants: number;
  private _color: string;
  private _created: Date;
  private _creator: string;
  private _description: string;
  private _equipments: string;
  private _modified: Date;
  private _modifier: string;
  private _picture: string;
  private _salleName: string;
  private _loading: boolean;
  private _events: EventCalendar[];
  private _srcImage: any;

  constructor(data: any) {
    this.id = data.id;
    this.allowedParticipants = data.allowedParticipants;
    this.created = new Date(data.created.replace('Z', ''));
    this.color = data.color;
    this.creator = data.creator;
    this.description = data.description;
    this.equipments = data.equipments;
    this.modified = new Date(data.modified.replace('Z', ''));
    this.modifier = data.modifier;
    this.picture = data.picture;
    this.salleName = data.salleName;
    this.loading = false;
    this.events = null;
    this.srcImage = data.srcImage;
  }

  get allowedParticipants(): number {
    return this._allowedParticipants;
  }

  set allowedParticipants(value: number) {
    this._allowedParticipants = value;
  }

  get created(): Date {
    return this._created;
  }

  set created(value: Date) {
    this._created = value;
  }

  get creator(): string {
    return this._creator;
  }

  set creator(value: string) {
    this._creator = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get equipments(): string {
    return this._equipments;
  }

  set equipments(value: string) {
    this._equipments = value;
  }

  get modified(): Date {
    return this._modified;
  }

  set modified(value: Date) {
    this._modified = value;
  }

  get modifier(): string {
    return this._modifier;
  }

  set modifier(value: string) {
    this._modifier = value;
  }

  get picture(): string {
    return this._picture;
  }

  set picture(value: string) {
    this._picture = value;
  }

  get salleName(): string {
    return this._salleName;
  }

  set salleName(value: string) {
    this._salleName = value;
  }

  get color(): string {
    return this._color;
  }

  set color(value: string) {
    this._color = value;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    this._loading = value;
  }

  get events(): any[] {
    return this._events;
  }

  set events(value: any[]) {
    this._events = value;
  }

  get srcImage(): any {
    return this._srcImage;
  }

  set srcImage(value: any) {
    this._srcImage = value;
  }
}
